import styles from "./Loader.module.css";

export default function Loader() {
  return (
    <div className={`column align-center justify-center ${styles.loader}`}>
      <div className={styles.sound_wave}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
